var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("founding-date"),
        state: _vm.getState(_vm.$v.recipient.founding_date),
        feedbacks: _vm.feedbacks(_vm.$v.recipient.founding_date),
      },
    },
    [
      _c("EmdInput", {
        attrs: {
          placeholder: "DD/MM/AAAA",
          name: "founding_date",
          readonly: _vm.disabled,
          disabled: _vm.disabled,
        },
        on: { input: _vm.updateField },
        model: {
          value: _vm.founding_date,
          callback: function ($$v) {
            _vm.founding_date = $$v
          },
          expression: "founding_date",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }